import * as R from 'ramda';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MetadataContext } from '../../../providers/MetadataContext';

interface UserInfoData {
  did: string;
  validationId: string;
}

const userInfoIsEmpty = (userInfo?: UserInfoData): boolean => {
  return R.isNil(userInfo) || (R.isEmpty(userInfo?.did) && R.isEmpty(userInfo?.validationId));
};

export default function UserInfo(): JSX.Element {
  const { truncatedDid, truncatedValidationId } = useContext(MetadataContext);
  const [userInfo, setUserInfo] = useState<UserInfoData>();
  const { t } = useTranslation();

  useEffect(() => {
    // Only show the first 6 digits of the did and validationId
    setUserInfo({
      did: truncatedDid(),
      validationId: truncatedValidationId(),
    });
  }, []);

  return (
    <>
      {!userInfoIsEmpty(userInfo) && (
        <div className="my-1 text-xs leading-5 pt-3 text-textTertiary pass-status-text" data-testid="USER_INFO">
          {t('screens.documentPass.common.userInfo.label', {
            validationId: userInfo?.validationId,
            did: userInfo?.did,
          })}
        </div>
      )}
    </>
  );
}
